import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DetectDeviceService {
  private isMobileDevice: boolean;

  constructor() {
    this.detectDevice();
    this.listenForResize();
  }

  private detectDevice(): void {
    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
    const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
    this.isMobileDevice = mobileRegex.test(userAgent) || window.innerWidth <= 768;
  }

  private listenForResize(): void {
    window.addEventListener('resize', () => {
      this.detectDevice();
    });
  }

  isMobile(): boolean {
    return this.isMobileDevice;
  }
}
